import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {ProviderDTO} from '../models/ProviderDTO';
import {ProviderUploadDTO} from '../models/ProviderUploadDTO';

@Injectable({
  providedIn: 'root'
})
export class ProviderService {
  private url = environment.baseUrl + '/provider';

  constructor(private httpClient: HttpClient) {
  }

  getListOfProviders(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<ProviderDTO>> {
    return this.httpClient.post<PagedResponseDTO<ProviderDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  getProvider(providerId: number): Observable<ProviderDTO> {
    return this.httpClient.get<ProviderDTO>(this.url + '/' + providerId);
  }

  getProviderByPracticeNumber(practiceNo: string): Observable<ProviderDTO> {
    return this.httpClient.get<ProviderDTO>(this.url + '/byPracticeNumber?number=' + practiceNo);
  }

  deleteProvider(id: number) {
    return this.httpClient.delete<{}>(this.url + '/' + id);
  }

  addProvider(payload): Observable<any> {
    return this.httpClient.post<any>(this.url, payload);
  }

  getAllProviders(): Observable<ProviderUploadDTO[]> {
    return this.httpClient.get<ProviderUploadDTO[]>(this.url + '/get-all');
  }
}
